import { render, staticRenderFns } from "./informatedisclosure.vue?vue&type=template&id=377865ef&scoped=true&"
import script from "./informatedisclosure.vue?vue&type=script&lang=js&"
export * from "./informatedisclosure.vue?vue&type=script&lang=js&"
import style0 from "./informatedisclosure.vue?vue&type=style&index=0&id=377865ef&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377865ef",
  null
  
)

export default component.exports